<div class="card">
  <h1 class="modal-title fs-4 fw-semibold">{{'NOTIFICATIONS.TITLE' | translate}}</h1>
  <div class="modal-body fs-6">
    <p>{{ data.message }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" mat-dialog-close>{{'NOTIFICATIONS.CLOSE' | translate}}</button>
  </div>
</div>
